import React from 'react'
import LatinoTemplateDefault from 'src/components/template/la'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds } from 'src/constants/personalizationIds'
import styled from 'styled-components'

export default (props) => {
  return (
    <StyledContainer>
      <LatinoTemplateDefault
        location={props.location}
        lang="es"
        market="latino"
        video={videos.generic_soccer.videoUrl}
        title={'Ve El Clásico online'}
        subtitle="Real Madrid vs Barcelona en vivo en español"
        networkSet="soccerLatino"
        noteLink="/la/clasico/"
        sportId={sportIds.Soccer}
        leagueId={leagueIds['La Liga']}
      />
    </StyledContainer>
  )
}

const StyledContainer = styled.div``
